import { render, staticRenderFns } from "./contractType.vue?vue&type=template&id=5bb4de39&scoped=true"
import script from "./contractType.vue?vue&type=script&lang=js"
export * from "./contractType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4de39",
  null
  
)

export default component.exports